import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.css']
})
export class SwitchComponent implements OnInit {

  @Input()
  question: string;
  @Input()
  on: boolean;
  @Input()
  disabled: boolean;
  @Output()
  value: EventEmitter<boolean> = new EventEmitter<boolean>();
  selectedValue = false;

  constructor() {
  }

  ngOnInit(): void {
    this.selectedValue = this.on;
  }

}
